import React from 'react'
import {BaseButton, Box, Text} from '../../../../vanilla'
import {useRapidDeliveryStore, useBasketStore} from '../../../../store/hooks/useStore'
import {observer} from 'mobx-react'

export const RapidDelivery = observer(() => {
  const {
    isRapidDeliveryAvailable,
    rapidDeliveryMaxItems,
    isRapidDeliveryEnabledForStore,
    isRapidDeliveryBooked,
    bookRapidDelivery,
    cancelRapidDelivery
  } = useRapidDeliveryStore()
  
  const { deliveryPostalCode, currentDeliveryStoreId } = useBasketStore()

  const handleBookRapidDelivery = async () => {
    await bookRapidDelivery()
  }

  const handleCancelRapidDelivery = async () => {
    await cancelRapidDelivery()
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      backgroundColor="white"
      paddingX={["16px", "28px"]}
      paddingY="16px"
      gap="12px"
    >
      <Text variant="heading1">Rapid Delivery</Text>
      <Text borderBottom="1px" borderColor="gray200" paddingBottom="4px" marginBottom="12px">
        Need your groceries faster? Book a Rapid Delivery slot
      </Text>
      <Box display="flex" flexDirection="column" gap="8px" marginBottom="12px">
        <Text variant="text3">
          Delivery Postcode = {deliveryPostalCode || 'Not set'}
        </Text>
        <Text variant="text3">
          Store ID = {currentDeliveryStoreId || 'Not set'}
        </Text>
        <Text variant="text3">
          Rapid Delivery Enabled for Store = {String(isRapidDeliveryEnabledForStore)}
        </Text>
        <Text variant="text3">
          Rapid Delivery Booked = {String(isRapidDeliveryBooked)}
        </Text>
        <Text variant="text3">
          Enable Rapid Delivery (Global) = {String(isRapidDeliveryAvailable)}
        </Text>
        <Text variant="text3">
          Max Items = {rapidDeliveryMaxItems}
        </Text>
      </Box>
      <Box display="flex" flexDirection="column" gap="8px" alignItems="flex-end">
        {!isRapidDeliveryEnabledForStore && (
          <Text variant="text3" color="error" fontSize="sm">
            Rapid delivery is not available for this store
          </Text>
        )}
        <Box display="flex" gap="12px">
          {!isRapidDeliveryBooked ? (
            <BaseButton
              size="sm"
              variant="primary"
              maxHeight="40px"
              onClick={handleBookRapidDelivery}
              disabled={!isRapidDeliveryEnabledForStore}
            >
              <Text variant="unstyled" fontSize="inherit" lineHeight="inherit" paddingX="20px">
                Book Rapid Delivery
              </Text>
            </BaseButton>
          ) : (
            <BaseButton
              size="sm"
              variant="secondary"
              maxHeight="40px"
              onClick={handleCancelRapidDelivery}
            >
              <Text variant="unstyled" fontSize="inherit" lineHeight="inherit" paddingX="20px">
                Cancel Rapid Delivery
              </Text>
            </BaseButton>
          )}
        </Box>
      </Box>
    </Box>
  )
})
